<script setup>
import ModalComponent from "@/components/ModalComponent.vue";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "confirm"]);

const closeModal = () => {
  emit("update:modelValue", false);
};

const handleConfirm = () => {
  emit("confirm");
};
</script>

<template>
  <ModalComponent :modelValue="modelValue" @update:modelValue="closeModal">
    <template #header>
      <h5 class="modal-title">
        <i class="fas fa-exclamation-triangle text-danger mr-2"></i> Confirm
        Action
      </h5>
      <button type="button" class="close" @click="closeModal">
        <span>&times;</span>
      </button>
    </template>

    <template #default>
      <p>Are you sure you want to clear current course range pins?</p>
    </template>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="closeModal">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="handleConfirm"
        :disabled="loading"
      >
        <i class="fas fa-spin fa-spinner mr-1" v-if="loading"></i>
        Yes - Clear range pins
      </button>
    </template>
  </ModalComponent>
</template>
